.select {
	display: flex;

	@supports not (appearance: base-select) {
		--select-caret: url("data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'><path fill='%231b1b33' d='M8 12.5a.744.744 0 0 1-.53-.22L1.22 6.03a.75.75 0 1 1 1.061-1.061l5.72 5.72 5.72-5.72a.75.75 0 0 1 1.061 1.061l-6.25 6.25a.748.748 0 0 1-.53.22H8Z'/></svg>");

		@container style(--theme: dark) {
			--select-caret: url("data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'><path fill='%23e1e1f0' d='M8 12.5a.744.744 0 0 1-.53-.22L1.22 6.03a.75.75 0 1 1 1.061-1.061l5.72 5.72 5.72-5.72a.75.75 0 0 1 1.061 1.061l-6.25 6.25a.748.748 0 0 1-.53.22H8Z'/></svg>");
		}

		appearance: none;
		padding-right: calc(var(--size-5) + var(--size-4) + var(--size-3));
		background-image: var(--select-caret), var(--button-bgimage);
		background-repeat: no-repeat, no-repeat;
		background-position:
			right var(--size-5) center,
			center;
		background-size: var(--size-4), auto;
	}

	&,
	&::picker(select) {
		appearance: base-select;
	}

	&::picker-icon {
		display: none;
	}

	.icon {
		margin-left: auto;
		transition: rotate var(--duration);
	}

	&:open .icon {
		rotate: 0.5turn;
	}

	&::picker(select) {
		margin: var(--size-2) 0;
		padding: var(--size-2);
		background-color: var(--color-surface-elevated);
		border: var(--size-border) solid var(--color-border);
		border-radius: var(--radius-lg);
		corner-shape: squircle;
		box-shadow: var(--shadow-md);

		@container style(--theme: light) {
			background-clip: padding-box;
		}
	}

	option {
		padding: var(--size-2) var(--size-5) var(--size-2) var(--size-4);
		border-radius: var(--radius-md);
	}

	option:not(:disabled):where(:hover, :focus-visible) {
		background-color: var(--color-primary);
		color: var(--blue-100);
		outline: none;
	}
}

/* enter and leave animations */

.select {
	--duration: 0.2s;
	--show-duration: 0.2s;
	--hide-duration: 0.1s;
	--hidden-opacity: 0;
	--hidden-scale: 0.95;
	transition: all var(--hide-duration);

	&::picker(select) {
		opacity: 0;
		translate: 0 calc(-1 * var(--size-3));
		transition: all 0.1s allow-discrete;
	}

	&:open::picker(select) {
		transition: all var(--show-duration);
		opacity: 1;
		translate: 0;

		@starting-style {
			opacity: 0;
			translate: 0 calc(-1 * var(--size-3));
		}
	}
}
